import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SearchQualifications() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'すべて', icon: 'ri-apps-line' },
    { id: 'lifestyle', name: 'ライフスタイル', icon: 'ri-home-heart-line' },
    { id: 'beauty', name: '美容・健康', icon: 'ri-heart-pulse-line' },
    { id: 'food', name: '食・料理', icon: 'ri-restaurant-line' },
    { id: 'business', name: 'ビジネス', icon: 'ri-briefcase-line' }
  ];

  const qualifications = [
    {
      title: '整理収納アドバイザー',
      category: 'lifestyle',
      description: '快適な暮らしを実現する整理収納のプロフェッショナル資格',
      icon: 'ri-home-heart-line',
      color: 'from-orange-200/60 to-rose-200/60',
      difficulty: '初級',
      duration: '3ヶ月'
    },
    {
      title: 'アロマセラピスト',
      category: 'beauty',
      description: '香りで心と体を癒すアロマテラピーの専門家資格',
      icon: 'ri-flask-line',
      color: 'from-purple-200/60 to-pink-200/60',
      difficulty: '中級',
      duration: '4ヶ月'
    },
    {
      title: 'ハーブプロフェッショナル',
      category: 'food',
      description: 'ハーブの知識と活用法を極めたスペシャリスト資格',
      icon: 'ri-leaf-line',
      color: 'from-green-200/60 to-emerald-200/60',
      difficulty: '初級',
      duration: '3ヶ月'
    },
    {
      title: 'パーソナルカラープランナー',
      category: 'beauty',
      description: '似合う色を見つけ出すカラーコーディネートの専門家資格',
      icon: 'ri-palette-line',
      color: 'from-pink-200/60 to-rose-200/60',
      difficulty: '中級',
      duration: '4ヶ月'
    },
    {
      title: 'リンパケアセラピスト',
      category: 'beauty',
      description: 'リンパの流れを整え健康をサポートする施術のプロ資格',
      icon: 'ri-heart-pulse-line',
      color: 'from-blue-200/60 to-cyan-200/60',
      difficulty: '中級',
      duration: '5ヶ月'
    },
    {
      title: '薬膳プロフェッショナル',
      category: 'food',
      description: '食材の力で体を整える薬膳料理の専門家資格',
      icon: 'ri-restaurant-line',
      color: 'from-amber-200/60 to-yellow-200/60',
      difficulty: '中級',
      duration: '4ヶ月'
    }
  ];

  const filteredQualifications = selectedCategory === 'all'
    ? qualifications
    : qualifications.filter(q => q.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-orange-50/30 to-peach-50">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="mb-8">
          <button
            onClick={() => navigate('/home')}
            className="flex items-center gap-2 text-gray-500 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            <span>ホームに戻る</span>
          </button>
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl p-8 mb-8 border border-orange-100/50">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-700 mb-3">資格を探す</h1>
            <p className="text-gray-500">あなたに合った資格を見つけましょう</p>
          </div>

          <div className="flex flex-wrap gap-3 justify-center mb-8">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap border-2 ${selectedCategory === category.id
                    ? 'bg-gradient-to-r from-orange-300 to-rose-300 text-white border-transparent shadow-lg'
                    : 'bg-white/60 text-gray-600 border-orange-100/50 hover:border-orange-300/50 hover:bg-orange-50/30'
                  }`}
              >
                <i className={`${category.icon} mr-2`}></i>
                {category.name}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredQualifications.map((qual, index) => (
              <div
                key={index}
                className="group bg-white/60 backdrop-blur-sm border-2 border-orange-100/50 rounded-3xl p-6 hover:border-orange-300/50 hover:shadow-2xl hover:bg-white/80 transition-all duration-300"
              >
                <div className={`w-16 h-16 mx-auto mb-4 bg-gradient-to-br ${qual.color} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md`}>
                  <i className={`${qual.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-700 mb-2 text-center">{qual.title}</h3>
                <p className="text-sm text-gray-500 mb-4 leading-relaxed text-center">{qual.description}</p>
                <div className="flex items-center justify-center gap-4 pt-4 border-t border-orange-100/50 mb-4">
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <i className="ri-bar-chart-line text-orange-300"></i>
                    <span>{qual.difficulty}</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <i className="ri-time-line text-orange-300"></i>
                    <span>{qual.duration}</span>
                  </div>
                </div>
                <button
                  onClick={() => navigate('/exam-instructions')}
                  className="w-full bg-gradient-to-r from-orange-300 to-rose-300 text-white py-3 rounded-2xl font-medium hover:from-orange-400 hover:to-rose-400 transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
                >
                  詳細を見る
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-orange-50/60 backdrop-blur-sm border-2 border-orange-200/50 rounded-3xl p-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-orange-200/50 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-orange-400 text-xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-orange-600 mb-2">資格取得のメリット</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                資格を取得することで、専門知識が身につき、キャリアアップや独立開業の可能性が広がります。自分のペースで学習できるオンライン講座で、無理なく資格取得を目指せます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
